import { render, staticRenderFns } from "./add-organize-seal.vue?vue&type=template&id=18861112&scoped=true&"
import script from "./add-organize-seal.vue?vue&type=script&lang=js&"
export * from "./add-organize-seal.vue?vue&type=script&lang=js&"
import style0 from "./add-organize-seal.vue?vue&type=style&index=0&id=18861112&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18861112",
  null
  
)

export default component.exports